module.exports = __webpack_public_path__ + "static/img/渐变背景@2x.9c97c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/渐变背景@2x.png
// module id = EaN8
// module chunks = 192